import { PlannerBase } from '../../planner_base';
import watch   from "redux-watch";
import isEqual from 'is-equal';
import { save }        from "apps/actions/common";
import {
  Global,
} from '../model';
import {
  PLANNER_CLICK_PARTITION
} from 'apps/events';
import PlannerControllerBase from './base';
export default class TasksController extends PlannerControllerBase {
  constructor(tag){
    super(tag);
    document.addEventListener(PLANNER_CLICK_PARTITION, (e) => this.onClickPartition(e));
  }
  onClickPartition(e) {
    let total = parseInt(e.value);
    let task_id = e.task_id
    App.store.dispatch(save(this.saveParams(e.detail)));
  }
  saveParams(detail){
    let payload = Global.getPartitionPayload();    
    payload.params.memo['total'] = parseInt(detail.value);
    payload.params.memo['task_id'] = detail.task_id;
    return payload;
  }
}
